import { render, staticRenderFns } from "./PageMeal.vue?vue&type=template&id=47886bca"
import script from "./PageMeal.vue?vue&type=script&lang=js"
export * from "./PageMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports